/* BONO — minimal purchase enhancements. Progressive: form works without JS. */
(function () {
  var qtyWrap = document.querySelector('[data-bono-qty]');
  if (qtyWrap) {
    var input = qtyWrap.querySelector('input[name="quantity"]');
    qtyWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-step]');
      if (!btn || !input) return;
      e.preventDefault();
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.step, 10);
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  var form = document.querySelector('[data-bono-buy]');
  var added = document.querySelector('[data-bono-added]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; /* fallback: native POST */
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.busy || 'Toevoegen…'; }
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/javascript' }
      })
        .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
        .then(function () { return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-bono-count]').forEach(function (el) { el.textContent = cart.item_count; });
          if (added) added.setAttribute('data-open', 'true');
          if (btn) { btn.disabled = false; btn.textContent = original; }
        })
        .catch(function () { form.submit(); });
    });
  }

  var sticky = document.querySelector('[data-bono-sticky]');
  var anchors = document.querySelectorAll('[data-bono-sticky-after]');
  if (sticky && anchors.length && 'IntersectionObserver' in window) {
    var visible = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      sticky.setAttribute('data-show', visible.size === 0 ? 'true' : 'false');
    }, { rootMargin: '0px 0px -12% 0px' });
    anchors.forEach(function (el) { io.observe(el); });
  }
})();